import { render, staticRenderFns } from "./live-sharePage.vue?vue&type=template&id=18404af0"
import script from "./live-sharePage.vue?vue&type=script&lang=js"
export * from "./live-sharePage.vue?vue&type=script&lang=js"
import style0 from "./live-sharePage.vue?vue&type=style&index=0&id=18404af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports